/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_bb_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How much team value can I realistically gain?`)
};

const es_f1_bb_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cuánto valor de equipo puedo ganar de forma realista?`)
};

const de_f1_bb_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie viel Teamwert kann ich realistisch gewinnen?`)
};

const nl_f1_bb_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoeveel teamwaarde kan ik realistisch gezien opbouwen?`)
};

const fr_f1_bb_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Combien de valeur d'équipe puis-je raisonnablement gagner ?`)
};

const it_f1_bb_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quanto valore di squadra posso realisticamente guadagnare?`)
};

const pt_br2_f1_bb_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quanto valor de equipe eu posso ganhar de forma realista?`)
};

const pt_f1_bb_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quanto valor de equipa posso ganhar realisticamente?`)
};

const ja_f1_bb_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`現実的にどれくらいチームの資産価値を増やせますか？`)
};

const zh_f1_bb_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我实际能获得多少车队身价增值？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_bb_faq4_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_bb_faq4_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_bb_faq4_q", locale)
	if (locale === "en") return en_f1_bb_faq4_q(inputs)
	if (locale === "es") return es_f1_bb_faq4_q(inputs)
	if (locale === "de") return de_f1_bb_faq4_q(inputs)
	if (locale === "nl") return nl_f1_bb_faq4_q(inputs)
	if (locale === "fr") return fr_f1_bb_faq4_q(inputs)
	if (locale === "it") return it_f1_bb_faq4_q(inputs)
	if (locale === "pt-BR") return pt_br2_f1_bb_faq4_q(inputs)
	if (locale === "pt") return pt_f1_bb_faq4_q(inputs)
	if (locale === "ja") return ja_f1_bb_faq4_q(inputs)
	return zh_f1_bb_faq4_q(inputs)
};